import React from 'react';
import { Alert, Card, CardContent, CardHeader, Stack } from '@mui/material';

import FileUpload from '../shared/FileUpload';
import BankCsvEditDialog from './bank-csv-import/BankCsvEditDialog';
import BankCsvImportReport from './bank-csv-import/BankCsvImportReport';
import BankCsvMappingSection from './bank-csv-import/BankCsvMappingSection';
import BankCsvPreviewSection from './bank-csv-import/BankCsvPreviewSection';
import useBankCsvImport from './bank-csv-import/useBankCsvImport';

const BankCsvImportPanel = ({ onImportSuccess }) => {
    const {
        selectedFile,
        previewData,
        previewWarnings,
        headers,
        mapping,
        saveMapping,
        selection,
        importResult,
        importError,
        loadingPreview,
        loadingImport,
        editDialogOpen,
        editingRow,
        editedPurpose,
        rows,
        selectableCount,
        selectedCount,
        allSelected,
        someSelected,
        selectionEmpty,
        setSaveMapping,
        setEditedPurpose,
        setEditDialogOpen,
        handleFileSelect,
        handlePreview,
        handleImport,
        clearPreview,
        handleMappingChange,
        handleToggleAll,
        handleToggleRow,
        handleRowClick,
        handleSaveChanges,
    } = useBankCsvImport({ onImportSuccess });

    const mappingOptions = headers.map((header, index) => ({
        value: index,
        label: `${index + 1}: ${header || `Spalte ${index + 1}`}`,
    }));

    return (
        <Card sx={{ borderRadius: 3, boxShadow: '0 8px 28px rgba(0,0,0,0.06)' }}>
            <CardHeader
                title="Bankdaten (CSV) importieren"
                subheader="CSV-Datei hochladen, Spalten zuordnen, Vorschau pruefen und Transaktionen importieren."
            />
            <CardContent>
                <Stack spacing={2}>
                    <FileUpload
                        onFileSelect={handleFileSelect}
                        onPreview={handlePreview}
                        onImport={handleImport}
                        onReset={clearPreview}
                        accept=".csv"
                        loadingPreview={loadingPreview}
                        loadingImport={loadingImport}
                        selectedFile={selectedFile}
                        importDisabled={!previewData || Boolean(selectionEmpty)}
                    />

                    {importError && <Alert severity="error">{importError}</Alert>}

                    {previewWarnings.map((warning, index) => (
                        <Alert key={`bank-preview-${index}`} severity="warning">
                            {warning}
                        </Alert>
                    ))}

                    <BankCsvMappingSection
                        headers={headers}
                        mapping={mapping}
                        mappingOptions={mappingOptions}
                        saveMapping={saveMapping}
                        loadingPreview={loadingPreview}
                        loadingImport={loadingImport}
                        onMappingChange={handleMappingChange}
                        onToggleSaveMapping={setSaveMapping}
                    />

                    <BankCsvPreviewSection
                        previewData={previewData}
                        rows={rows}
                        selection={selection}
                        selectableCount={selectableCount}
                        selectedCount={selectedCount}
                        allSelected={allSelected}
                        someSelected={someSelected}
                        onToggleAll={handleToggleAll}
                        onToggleRow={handleToggleRow}
                        onRowClick={handleRowClick}
                    />

                    <BankCsvImportReport importResult={importResult} />
                </Stack>
                <BankCsvEditDialog
                    open={editDialogOpen}
                    editingRow={editingRow}
                    editedPurpose={editedPurpose}
                    onPurposeChange={setEditedPurpose}
                    onClose={() => setEditDialogOpen(false)}
                    onSave={handleSaveChanges}
                />
            </CardContent>
        </Card>
    );
};

export default BankCsvImportPanel;
